import store from '@/store'
const Forum = () => import("@/views/forum/Forum.vue")
const LiveFeed = () => import("@/views/forum/LiveFeed.vue")
const PostInDetail = () => import("@/views/forum/PostInDetail.vue")


export default {
    path: "/forum",
    component: Forum,
    children: [
        { name: "forum", path: "", component: LiveFeed },
        { name: "post-in-detail", path: "posts/:postId", component: PostInDetail }
    ],
    //return the user to login page if they are not authenticated
    beforeEnter: (from, to, next) => {
        if (!store.getters["auth/authenticated"]) {
            return next({
                name: "login"
            })
        }
        next()
    }
}